import { Select } from "@material-ui/core";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
  Button,
  Box,
  IconButton,
  //Checkbox,
  FormControlLabel,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import Checkbox from '@material-ui/core/Checkbox';


const roles = ["Admin", "Sales Engineer", "Designer"];
const ZcodeDailog = React.memo(
  ({ open, onClose, onSave, onUpdate, userToEdit }) => 
  {
    const [error, setError] = useState("");
    const [checkedIn, setCheckedIn] =useState(false);
    const [formData, setFormData] = useState({
      CategoryId: 0,
      zcode: "",
      zCodeDescription: "",
      status:"",
      isActive: checkedIn,

      
     
    });
    const userdetails = useSelector(
        (state) => state.storeUserDetailsReducer.userData
      );
      const siteToken = useSelector((state) => state.saveTokenReducer);
      const azureToken = useSelector((state) => state.saveAzureTokenReducer);
      const zcodes = useSelector((state)=>state.storeZCodesReducer);
    useEffect(() => {
      setError("");
      console.log('dialog recieve',zcodes);
      if(userToEdit?.editUser?.isActive !==undefined){
        setCheckedIn(userToEdit?.editUser?.isActive)
       }else{
        setCheckedIn(false)
       }

     setFormData({
          isActive: checkedIn,
          categoryId: userToEdit?.editUser?.categoryId || 0,
          zcode: userToEdit?.editUser?.zcode,
          zCodeDescription: userToEdit?.editUser?.zCodeDescription,
          model:"test",
          checkIsActive:checkedIn? "ON" : "OF",
          status:checkedIn ? "Active" : "InActive",
        });
        
      
     }, [userToEdit]);
   

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        setError("");
    };
    const handleSave = (e) => {
      console.log(e.target.name);
      console.log(e.target.value);
      let zcodesExist = zcodes?.menuItems?.filter((x)=>x.zcode  == formData.zcode).length;
      const zcodeRegex = /^[a-zA-Z]{1}\d{2}$/;
      if (!formData.zcode || !formData.zCodeDescription) {
        setError("Al fields are required");
        return;
      }else if(!zcodeRegex.test(formData.zcode)){
        setError("Please Enter Z-Code with one character and 2 digit");
        return;
      }else if(zcodesExist > 0 && !userToEdit.editUser ){
        setError("Zcodes is already present")
      }
      else if (userToEdit?.editUser) {
        onUpdate(formData);
      } else {
        onSave(formData);
      }
    };

   const handleCheckChange=()=>
    {
      setCheckedIn(!checkedIn)
      setFormData({
        ...formData,
        isActive:!checkedIn,
        status:!checkedIn ? "Active" : "InActive",
        checkIsActive:!checkedIn? "ON" : "OF",
        
      });
     
  }
   
    return (
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
        <DialogTitle sx={{ fontWeight: "bold", textAlign: "left" }}>
          {userToEdit.editUser ? "Update Z-Code" : "Create Z-Code"}
          <IconButton
            onClick={onClose}
            style={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 3, mb: 3 }}>
            <TextField
              label="ZCode"
              name="zcode"
              value={formData?.zcode}
              variant="standard"
              onChange={handleChange}
              fullWidth
              required
              sx={{
                width: "48%",
                "& .MuiFormLabel-asterisk": { color: "red" },
              }}
            />

            <TextField
              label="Description"
              name="zCodeDescription"
              variant="standard"
              value={formData?.zCodeDescription}
              onChange={handleChange}
              fullWidth
              required
              sx={{
                width: "48%",
                "& .MuiFormLabel-asterisk": { color: "red" },
              }}
            />
          </Box>
          {error && (
            <Typography color="error" sx={{ mt: 2, textAlign: "center" }}>
              {error}
            </Typography>
          )}
        </DialogContent>

        <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
          <Button 
            className="btn"
            onClick={handleSave}
            variant="contained"
            color="primary"
            sx={{ width: "120px", ml: 2 }}
          >
            {userToEdit.editUser ? "Update" : "Save"}
          </Button>
        </DialogActions>  

        <Box sx={{ display: "flex",alignItems:"center", gap: 2}}>
        {userToEdit.editUser && (
          <FormControlLabel
          control={
        <Checkbox style={{color: "#1976d2",left:"28px",bottom:"56px"}}
        checked={checkedIn}
        onChange={handleCheckChange}
        />
        
         }
         
        
        />)
          }
       {userToEdit.editUser && <Typography sx={{ mt: 2, textAlign: "center", position:"relative",
                  top: "-61px"}}>
              Is Active
            </Typography>
        }
        
          </Box>
  

      </Dialog>
    )
  }
);

export default ZcodeDailog;
